<script>
import { mapActions } from 'vuex'
import UITags from '@components/ui-components/tags/tags.vue'

export default {
  name: 'ui-events-list-item',
  components: {
    'ui-tags': UITags,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    splittedStartDate() {
      const [year, month, day, time] = this.item.dateStart.split(/\s|\-/)

      return { year, month: Number(month), day: Number(day), time }
    },
    dayStart() {
      return this.splittedStartDate.day
    },
    monthStart() {
      return this.$root.staticText.month[this.splittedStartDate.month - 1]
    },
    timeStart() {
      return this.splittedStartDate.time
    },
    leftDays() {
      if (!this.item.dateEndReg) return this.$root.staticText.events.regEnd

      let timeDiff = new Date(this.item.dateEndReg) - new Date()
      let count = Math.round(timeDiff / (1000 * 60 * 60 * 24))
      let left = this.$root.num2str(count, this.$root.staticText.events.left)
      let days = this.$root.num2str(count, this.$root.staticText.events.days)

      return {
        phrase: count < 0 ? this.$root.staticText.events.regEnd : left + ' ' + count + ' ' + days,
        isEndReg: count < 0,
      }
    },
  },
  methods: {
    ...mapActions('modal', {
      modalClose: 'modalClose',
    }),
  },
}
</script>

<template>
  <div class="t-events-list__item">
    <div class="t-events-list__left">
      <div class="t-events-list__row">
        <div class="t-events-list__img">
          <img v-if="item.img" :src="item.img" :alt="item.title" />
        </div>
        <div class="t-events-list__content">
          <div class="t-events-list__vendors">
            <template v-for="vendor in item.vendors">
              <template v-if="vendor.image">
                <a v-if="vendor.link" v-link :href="vendor.link" class="t-events-list__vendors-item">
                  <img :src="vendor.img" :alt="vendor.name" />
                </a>

                <span v-else class="t-events-list__vendors-item">
                  <img :src="vendor.img" :alt="vendor.name" />
                </span>
              </template>
            </template>
          </div>

          <a class="t-events-list__title t-subtitle" v-link :href="item.link">
            {{ item.title }}
          </a>

          <div class="t-events-list__text">{{ item.text }}</div>
        </div>
      </div>
      <ui-tags
        :tags="item.categories"
        class="t-events-list__categories _views"
        :disable-filter="true"
        :white="true"
        :is-container="false"
      ></ui-tags>
    </div>

    <div class="t-events-list__right">
      <div class="t-events-list__right-container">
        <div class="t-events-list__mark">{{ item.mark }}</div>
        <div class="t-events-list__row t-events-list__right-date">
          <div class="t-events-list__date t-subtitle">
            <span>{{ dayStart }}</span>
            <span>{{ monthStart }}</span>
            <span>{{ splittedStartDate.year }}</span>
          </div>
          <div class="t-events-list__time t-subtitle">
            <span>{{ timeStart }}</span>
          </div>
        </div>
      </div>

      <template v-if="item.availableReg">
        <!--Внутренняя-->
        <a v-if="item.eventArea === 1" v-link class="t-btn _green t-events-list__btn _big" :href="`${item.link}#event-reg-form`">
          Зарегистрироваться
        </a>

        <!--Внешняя-->
        <a
          v-else-if="item.eventArea === 2 && item.externalAreaUrl.length > 0"
          v-link
          class="t-btn _green t-events-list__btn _big"
          :href="item.link"
        >
          Зарегистрироваться
        </a>
      </template>

      <div class="t-events-list__bottom">
        {{ leftDays.phrase }}
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/templates/pages/events/components/events-list/events-list-item.vue